/** The gun you reach for when the primary runs dry mid-fight. */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const SIDEARM_SLOT = {
  id: 'sidearm',
  label: 'Sidearm',
  description: 'The gun you reach for when the primary runs dry mid-fight.',
} as const satisfies EquipmentSlot;
